<template>
    <div>
        <v-row no-gutters class="align-center">
            <v-col cols="12" class="pl-2 pt-1 pb-2">
                <v-select-filled
                    v-model="log"
                    :items="logs"
                    item-filter="filter"
                    :hide-details="true"
                    :readonly="readonly"
                    density="compact"
                    :item-title="(item) => item.text"
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="align-center">
            <v-col cols="12" class="pl-2 py-2">
                <v-text-field-filled
                    :hide-details="true"
                    v-model="generalWording"
                    label="Libellé de l'écriture"
                    class="mt-0"
                    :disabled="!!bankTransactionId"
                    :readonly="readonly"
                    density="compact"
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="align-center">
            <v-col cols="12" class="pl-2 py-2">
                <v-text-field-filled
                    v-model="invoiceNumber"
                    hide-details
                    label="N&#xb0; de pièce"
                    v-if="!bankTransactionId"
                    :readonly="readonly"
                    density="compact"
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="align-center">
            <v-col cols="12" class="pl-2 pb-2 pt-1">
                <oss-date-picker-filled
                    v-model="date"
                    :filterWithoutClosedAccountingPeriods="!readonly"
                    hide-details
                    label="Date de l'écriture"
                    :textFieldReadOnly="false"
                    :disabled="!!bankTransactionId"
                    :readonly="readonly"
                />
            </v-col>
        </v-row>
        <v-row no-gutters class="align-center">
            <v-col cols="12" class="pl-2 pb-2 pt-1">
                <oss-date-picker-filled
                    v-model="dueDate"
                    hide-details
                    label="Date d'échéance"
                    :textFieldReadOnly="false"
                    :disabled="!!bankTransactionId"
                />
            </v-col>
        </v-row>
        <template v-for="(al, i) in accountingLines" :key="`divider-${i}`">
            <!-- <v-divider
                :class="{
                    'mt-1': fullMode,
                }"
                style="border-width: 1px"
            /> -->
            <!-- <v-list-item :key="`al-${i}`" class="px-2"> -->
            <!-- <template class="py-1"> -->
            <v-row no-gutters>
                <v-col :cols="readonly ? 12 : 11">
                    <v-row no-gutters v-if="fullMode" class="pb-1">
                        <v-col cols="12" class="pr-1">
                            <v-text-field-filled
                                :hide-details="true"
                                v-model="al.wording"
                                @change="onItemWordingChanged(al)"
                                class="pb-1"
                                :readonly="readonly"
                                :disabled="al.isBankTransaction || !!al.tag"
                                v-if="fullMode"
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-if="fullMode" class="pb-1">
                        <v-col cols="6" class="pr-1">
                            <FreeTag
                                :inPrimaryLog="'XXXXXX'"
                                :companyTags="companyTags"
                                :company="selectedCompany"
                                :documentType="type"
                                :accountingLine="al"
                                @onTagsChanged="onAccountingLineTagsChanged($event)"
                                v-if="!al.tag"
                            />
                            <div v-else>
                                <v-chip label color="tagFree" size="small">{{
                                    al.tag.name
                                }}</v-chip>
                            </div>
                        </v-col>
                        <v-col cols="3" class="pr-1">
                            <oss-date-picker-filled
                                v-model="al.date"
                                :filterWithoutClosedAccountingPeriods="!readonly"
                                hide-details
                                :readonly="readonly"
                                :textFieldReadOnly="false"
                                :disabled="al.isBankTransaction || !!al.tag"
                                :outlined="false"
                                :no-menu="true"
                            />
                        </v-col>
                        <v-col cols="3" class="pl-1">
                            <oss-date-picker-filled
                                v-if="!!al.paymentStatus"
                                v-model="al.dueDate"
                                hide-details
                                placeholder="Date d'échéance"
                                :textFieldReadOnly="false"
                                :disabled="al.isBankTransaction || !!al.tag"
                                :notRequired="true"
                                :outlined="false"
                                :no-menu="true"
                                @update:model-value="onDueDateChanged(al, $event)"
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="pb-1">
                        <v-col cols="6" class="pr-1">
                            <AccountableAccount
                                :inAccountableAccounts="accountableAccounts"
                                :thirdParty="al.thirdPartyCompany || al.user || al.bankAccount"
                                :show-validation="false"
                                hide-details
                                :company-id="companyId"
                                :edit-sub-accountable-account="false"
                                label="Compte comptable"
                                :inputStyle="'padding: 0'"
                                :disabled="readonly || al.isBankTransaction || !!al.tag"
                                :editAccountableAccount="true"
                                @update:model-value="setAccountableAccount(al, $event)"
                                :defineThirdParty="true"
                                :model-value="al.accountableAccount"
                                rounded="0"
                            />
                        </v-col>
                        <v-col cols="3" class="px-1">
                            <oss-text-field-filled
                                :hide-details="true"
                                :outlined="false"
                                rounded="0"
                                suffix="D"
                                :readonly="readonly"
                                @change="onItemDebitChanged(al)"
                                :rules="[
                                    (v) =>
                                        (v !== '' && parseFloat(v) >= 0.0) ||
                                        $t('settings.positiveNumber'),
                                ]"
                                :disabled="al.isBankTransaction || !!al.tag"
                                v-model="al.debit"
                            />
                        </v-col>
                        <v-col cols="3" class="pl-1">
                            <oss-text-field-filled
                                :hide-details="true"
                                :outlined="false"
                                rounded="0"
                                suffix="C"
                                :readonly="readonly"
                                @change="onItemCreditChanged(al)"
                                :rules="[
                                    (v) =>
                                        (v !== '' && parseFloat(v) >= 0.0) ||
                                        $t('settings.positiveNumber'),
                                ]"
                                :disabled="al.isBankTransaction || !!al.tag"
                                v-model="al.credit"
                            />
                        </v-col>
                    </v-row>
                    <!-- {{  al }} -->
                </v-col>
                <v-col v-if="!readonly" class="d-flex align-center">
                    <v-btn-trash @click="deleteRow(al)" v-if="!al.tag" size="small" />
                </v-col>
            </v-row>
        </template>
        <v-divider
            :class="{
                'mt-1': fullMode,
            }"
            style="border-width: 1px"
        />
        <v-row no-gutters>
            <v-col :cols="readonly ? 12 : 11">
                <v-row no-gutters>
                    <v-col cols="6" class="pr-2 d-flex align-center body-1">
                        <v-spacer />
                        Totaux
                    </v-col>
                    <v-col class="px-2 d-flex align-center body-1">
                        {{ newCommonFormatCurrency(totalDebit, undefined) }}
                    </v-col>
                    <v-col class="pl-2 d-flex align-center body-1">
                        {{ newCommonFormatCurrency(totalCredit, undefined) }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col v-if="!readonly" class="d-flex align-center">
                <v-btn-add-icon size="x-small" @click="addRow()"> </v-btn-add-icon>
            </v-col>
        </v-row>

        <!-- <v-row no-gutters>
                <v-col cols="6" class="pr-2 d-flex align-center body-1">
                    <v-spacer />
                    Totaux
                </v-col>
                <v-col class="px-2 d-flex align-center body-1">
                    {{ newCommonFormatCurrency(totalDebit, undefined) }}
                </v-col>
                <v-col class="pl-2 d-flex align-center body-1">
                    {{ newCommonFormatCurrency(totalCredit, undefined) }}
                </v-col>
            </v-row>
            <template v-slot:append style="width: 28px" v-if="!readonly">
                <v-btn-add-icon size="x-small" @click="addRow()"> </v-btn-add-icon>
            </template> -->
    </div>
</template>

<script lang="ts">
import { AccountingItemEditionBase2 } from "./AccountingItemEditionBase2";
import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices";
import { Component, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({})
export class AccountingItemEditionEmbedded extends AccountingItemEditionBase2 {
    @Prop({ default: false }) fullMode!: boolean;

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }
}

export default toNative(AccountingItemEditionEmbedded);
</script>

<style scoped>
.v-input__slot {
    padding: 1px 0 !important;
}
</style>
